export const ADD_PRODUCT_SUCCESS_MESSAGE =
    'New product has been created successfully'
export const ADD_PRODUCT_ERROR_MESSAGE =
    'An error occured while trying to save changes. Please try again.'
export const DUPLICATE_PRODUCT_MESSAGE =
    'Duplicate product name exists, choose another name or cancel.'

export const ADD_PROPRIETARY_CATEGORY_SUCCESS_MESSAGE =
    'New product has been created successfully'
export const ADD_PROPRIETARY_CATEGORY_ERROR_MESSAGE =
    'An error occured while trying to save categories to family. Please try again.'
